import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatReminderMessage } from '../../../utils/notificationUtils';

const ReminderIndicator = ({ reminders, onDismiss }) => {
  if (!reminders || reminders?.length === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 space-y-3 max-w-sm">
      {reminders?.slice(0, 3)?.map(reminder => (
        <div
          key={reminder?.id}
          className="bg-card border-2 border-primary rounded-lg shadow-warm-lg p-4 animate-slide-up"
        >
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
              <Icon name="bell" size={20} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground mb-1">
                {reminder?.memberName}
              </p>
              <p className="text-sm text-muted-foreground">
                {formatReminderMessage(reminder)}
              </p>
              {reminder?.isRecurring && (
                <div className="flex items-center gap-1 mt-2">
                  <Icon name="repeat" size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">Recurring</span>
                </div>
              )}
            </div>
            <button
              onClick={() => onDismiss?.(reminder?.id)}
              className="flex-shrink-0 text-muted-foreground hover:text-foreground transition-colors"
              aria-label="Dismiss reminder"
            >
              <Icon name="x" size={16} />
            </button>
          </div>
        </div>
      ))}
      {reminders?.length > 3 && (
        <div className="text-center">
          <p className="text-xs text-muted-foreground">
            +{reminders?.length - 3} more reminder{reminders?.length - 3 > 1 ? 's' : ''}
          </p>
        </div>
      )}
    </div>
  );
};

export default ReminderIndicator;